import Vue from 'vue'
import crypto from 'crypto'
import httpManager from '../../util/common'

Vue.config.productionTip = false

let vm = {
  name: 'Login',
  data: () => {
    return {
      pwdShow: false,
      pwdErrMsg: null,
      pwdErrMsgShow: false,
      userErrMsg: null,
      userErrMsgShow: false,
      mailErrMsg: null,
      mailErrMsgShow: false,
      password: null,
      username: null,
      hasChecked: false,
      agentCode: "gzjrfz"
    }
  },
  methods: {
    changeLocale () {
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'en'
        this.$store.dispatch('setLocale', 'en')
        this.another_locale = '中文'
      } else {
        this.$i18n.locale = 'zh'
        this.$store.dispatch('setLocale', 'zh')
        this.another_locale = 'En'
      }
    },
    changeCheckedStatus () {
      this.hasChecked = !this.hasChecked
    },
    switchPwd () {
      this.pwdShow = !this.pwdShow
    },
    inputOnFocus () {
      this.userErrMsgShow = false
      this.pwdErrMsgShow = false
    },
    on_submit (e) {
      let self = this
      if (!self.username) {
        self.userErrMsg = self.$t('login.emailRequired')
        self.userErrMsgShow = true
        return
      }
      let regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (self.username && !regEmail.test(self.username)) {
        self.userErrMsg = self.$t('login.invalidEmail')
        self.userErrMsgShow = true
        return
      }
      if (!self.password) {
        self.pwdErrMsg = self.$t('login.pwdRequired')
        self.pwdErrMsgShow = true
        return
      }
      let md5 = crypto.createHash('md5')
      md5.update(self.password) // 需要加密的密码
      let password = md5.digest('hex')
      let body = {'username': self.username, 'password': password}
      // 是否记住密码
      if (self.hasChecked) {
        // 传入账号名，密码，和保存天数3个参数
        self.setCookie(self.username, self.password, self.hasChecked, 7)
      } else {
        // 清空Cookie 修改2值都为空，天数为负1天就好了
        self.setCookie('', '', '', -1)
      }
      httpManager('login', null, body)
        .then(response => {
          if (!response.data.success) {
            if (response.data.data.key === 'pwd') {
              self.pwdErrMsg = self.$t('login.wrongPwd')
            } else {
              self.userErrMsg = self.$t('login.notExist')
            }
            self[response.data.data.key + 'ErrMsgShow'] = true
            return
          }
          sessionStorage.setItem('username', self.username)
          sessionStorage.setItem('agentcode', self.agentCode)
          if (self.$route.query.redirect) {
            self.$router.push(this.$route.query.redirect)
          } else {
            self.$router.push('/home')
          }
        })
        .catch(error => {
          self['pwdErrMsg'] = self.$t('login.loginError')
          self['pwdErrMsgShow'] = true
          console.log(error)
        })
    },
    // 设置cookie
    setCookie (cName, cPwd, hasChecked, exdays) {
      let exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'username' + '=' + cName + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'password' + '=' + cPwd + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'hasChecked' + '=' + hasChecked + ';path=/;expires=' + exdate.toGMTString()
    },
    getCookie () {
      if (document.cookie.length > 0) {
        let arr = document.cookie.split('; '); // 这里显示的格式需要切割一下自己可输出看下
        for (let i = 0; i < arr.length; i++) {
          let arr2 = arr[i].split('='); // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'username') {
            this.username = arr2[1]; // 保存到保存数据的地方
          } else if (arr2[0] === 'password') {
            this.password = arr2[1];
          } else if (arr2[0] === 'hasChecked') {
            this.hasChecked = arr2[1];
          }
        }
      }
    },
    getLocaleValue () {
      if (window.location.search.substring(1)) {
        let key = window.location.search.substring(1).split('=')[0]
        let lang = window.location.search.substring(1).split('=')[1]
        if (key !== 'lang') {
          return
        }
        if (lang === 'en') {
          this.$i18n.locale = 'en'
          this.$store.dispatch('setLocale', 'en')
          this.another_locale = '中文'
        } else {
          this.$i18n.locale = 'zh'
          this.$store.dispatch('setLocale', 'zh')
          this.another_locale = 'En'
        }
      }
    }
  },
  mounted () {
    this.getCookie()
    this.getLocaleValue()
  }
}
export default vm



// WEBPACK FOOTER //
// ./src/home/js/gzjrfz_login.js